import {defineStore} from 'pinia';
import {useThemeStore} from "@js/store/ThemeStore.js";
import baseImg from '@img/callback/base.webp'
import {checkDocument} from "@js/helpers.ts";

const baseFormDefaultData = {
    title: 'Обратный звонок',
    description: 'Оставьте заявку,\n мы вам перезвоним',
    bitrix_title: 'Заявка на обратный звонок c сайта ФУЛЛ СТРОЙ',
    img_src: baseImg,
    data: {
        full_name: '',
        phone: '',
        captcha_token: '',
    },
    errors: [],
    isOpen: false,
    animation_in_progress: false,
    sending: false,
    successfully_sent: false,
}

export const useCallbackStore = defineStore('callbackStore', {
    state: () => ({
        base_form: {...baseFormDefaultData}
    }),
    actions: {
        showBaseCallbackPopup(data = {}) {
            if (data.title !== undefined) {
                this.base_form.title = data.title
            }
            if (data.img_src !== undefined) {
                this.base_form.img_src = data.img_src
            }
            if (data.bitrix_title !== undefined) {
                this.base_form.bitrix_title = data.bitrix_title
            }
            if (data.comment !== undefined) {
                this.base_form.data.comment = data.comment
            }

            this.base_form.isOpen = true
            this.base_form.successfully_sent = false
        },
        closeCallbackPopup() {
            Object.assign(this.base_form, structuredClone(baseFormDefaultData))
        },
        sendPopupForm() {
            if (!checkDocument()) return;

            this.base_form.errors = []
            this.base_form.sending = false
            this.base_form.data.captcha_token = ''
            this.base_form.successfully_sent = false

            const captchaId = 'smart-captcha-container-base-callback'

            // 1. Удаляем предыдущий контейнер и сбрасываем предыдущую капчу
            const existingContainer = document.getElementById(captchaId)
            if (existingContainer) {
                try {
                    // Пытаемся уничтожить по id (если это был widgetId)
                    window.smartCaptcha.destroy(existingContainer.dataset.widgetId)
                } catch (e) {
                }
                existingContainer.remove()
            }

            // 2. Создаём новый контейнер
            const container = document.createElement('div')
            container.id = captchaId
            container.style.position = 'absolute'
            container.style.zIndex = '-1'
            document.body.appendChild(container)

            let tokenReceived = false

            // 3. Рендерим капчу и сохраняем widgetId
            const widgetId = window.smartCaptcha.render(captchaId, {
                sitekey: import.meta.env.VITE_YANDEX_SMARTCAPTCHA_SECRET,
                invisible: true,
                hideShield: true,
                callback: (token) => {
                    tokenReceived = true
                    this.base_form.sending = true
                    this.base_form.data.captcha_token = token

                    axios.post('/axios/form/send-form', {
                        bitrix_title: this.base_form.bitrix_title,
                        ...this.base_form.data,
                    }).then(() => {
                        this.base_form.sending = false
                        this.base_form.successfully_sent = true
                        this.base_form.data.captcha_token = ''

                        try {
                            window.smartCaptcha.destroy(widgetId)
                        } catch (e) {
                        }
                    }).catch(error => {
                        this.base_form.sending = false
                        if (error.response?.status === 422) {
                            this.base_form.errors = error.response.data.errors
                        }
                    })
                }
            })

            // Привязываем widgetId к контейнеру для возможного удаления позже
            document.getElementById(captchaId).dataset.widgetId = widgetId

            // 4. Обработка закрытия пользователем (✕)
            window.smartCaptcha.subscribe(widgetId, 'challenge-hidden', () => {
                if (!tokenReceived) {
                    this.base_form.sending = false
                    this.base_form.errors = {
                        captcha_token: ['Вы закрыли капчу. Повторите попытку.']
                    }

                    try {
                        window.smartCaptcha.reset(widgetId)
                    } catch (e) {
                    }
                }
            })

            // 5. Запуск
            setTimeout(() => {
                try {
                    window.smartCaptcha.execute(widgetId)
                } catch (e) {
                    this.base_form.sending = false
                    this.base_form.errors = {
                        captcha_token: ['Не удалось запустить капчу. Попробуйте ещё раз.']
                    }
                }
            }, 100)
        }
    }
});
